import gql from 'graphql-tag';

export default gql`
mutation changeAppTags(
        $uuid: String!,
        $tag1: String,
        $tag2: String,
        $tag3: String,
        $tag4: String,
        $tag5: String
        ) {
    updateApps(input: {
        uuid: $uuid,
        tag1: $tag1,
        tag2: $tag2,
        tag3: $tag3,
        tag4: $tag4,
        tag5: $tag5
    }) {
        uuid
    }
}
`;
